<template>
    <v-card class="rounded-xl mx-0 px-0">
        <v-card-title class="px-5 pb-0">
            Documentos Excluidos
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text  class="px-4 pt-0">
            
            <v-row>
                <v-col cols="4">
                    <app-date-picker
                      aucomplete="off"
                      label="Fecha de exclusión (hasta)"
                      v-model="excludedDate"
                    ></app-date-picker>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-simple-table class="simple-table">
                        <template v-if="loadingExcludedFilesSave">
                            <v-progress-circular indeterminate color="primary" class="ma-4" />
                        </template>
                        <template v-else>
                            <thead>
                                <tr>
                                    <th v-for="header in excludedFilesHeaders" :key="header.text">
                                        {{ header.text }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-if="excludedFiles && excludedFiles.length > 0">
                                    <tr v-for="file in excludedFiles" :key="file.id">
                                        <td class="ma-0">{{ file.name }}</td>
                                        <td class="ma-0">
                                            <v-checkbox
                                                v-model="file.excluded"
                                                class="ma-0"
                                                dense
                                                hide-details
                                            />
                                        </td>
                                    </tr>
                                </template>
                                <tr v-else>
                                    <td colspan="2" class="text-center grey--text">No hay documentos excluidos</td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                    <div class="text-right pt-2">
                        <v-btn
                            @click="saveExcludedFilesConfig()"
                            color="primary"
                            class="mr-5"
                            :disabled="loadingExcludedFilesSave">
                            Guardar
                        </v-btn>
                    </div>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>     
</template>

<script>
import {LoadPathReportQuery} from "@/modules/load_path/app/LoadPathReportQuery.ts"
import { UpdateExcludedFilesCommand } from "@/modules/load_path/app/UpdateExcludedFiles.ts"
import { sync_command_dispatcher, query_dispatcher } from "@/api/client";
import AppDatePicker from '@/components/layout/AppDatePicker.vue';

export default {
    name: 'ExcludedFilesTable',
    components: {
        AppDatePicker
    },
    props: {
        load_path_id: {
            type: [String, Number],
            required: false,
            default: '',
        },
    },

    data() {
        return {
            excludedFiles: [],
            excludedDate: null,
            loadingExcludedFilesSave: false,
            popupExcludedFiles:false,
            excludedFilesHeaders: [
                {
                    text: 'Nombre',
                    value: 'name',
                    sortable: true,
                },
                {
                    text: 'Excluido',
                    value: 'excluded',
                    type: 'checkbox',
                    sortable:false
                },
            ]
        }
    },

    computed:{
        
    },

    async mounted() {
        await this.loadExcludedFilesConfig();
    },

    methods: {
        async loadExcludedFilesConfig() {
            this.loadingExcludedFilesSave = true;
            try {
                await new LoadPathReportQuery(query_dispatcher, this).run(this.load_path_id);
            } catch (error) {
                console.error(error);
                this.loadingExcludedFilesSave = false;
                this.$emit('excluded-files-updated-error');
            }
            this.loadingExcludedFilesSave = false;
        },
        async saveExcludedFilesConfig() {
            this.loadingExcludedFilesSave = true;
            try {
                await new UpdateExcludedFilesCommand(sync_command_dispatcher, this).run(this.load_path_id, this.excludedFiles, this.excludedDate);
            } catch (error) {
                console.error(error);
                this.loadingExcludedFilesSave = false;
                this.$emit('excluded-files-updated-error');
            }
            this.loadingExcludedFilesSave = false;
            await this.loadExcludedFilesConfig();
            this.$emit('excluded-files-updated');
        }
    }
};
</script>

<style scoped>
.simple-table {
    background-color: #DEDCFF !important;
}

::v-deep.simple-table thead>tr:not(.simple-table__action-bar)>th {
    background-color: #EBEAFF !important;
    border-radius: 0 !important;
    color: #66359B !important;
}

::v-deep.simple-table.simple-table--round-top thead>tr:not(.simple-table__action-bar)>th:first-of-type {
    border-radius: 0.5rem 0 0 0 !important;
}

::v-deep.simple-table.simple-table--round-top thead>tr:not(.simple-table__action-bar)>th:last-of-type {
    border-radius: 0 0.5rem 0 0 !important;
}

::v-deep.simple-table tbody>tr>td {
    background-color: #FFF !important;
}

::v-deep.simple-table tbody>tr>td:not(:last-of-type) {
    border-right: 1px solid #66359B;
}
</style>